import { get, post } from './index.js';

export const getGraphQLTokens = async () => get('/v2/graphql/tokens');

export const isGraphQLTokenExpired = async (jwtToken) =>
  post('/v2/graphql/is-token-expired', { jwtToken });
